import * as React from 'react';

export const esFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_297)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#C70318'
            />
            <mask
                id='mask0_1_297'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_297)'>
                <path
                    d='M25.3333 0H2.66667C1.19391 0 0 1.19391 0 2.66667V17.3333C0 18.8061 1.19391 20 2.66667 20H25.3333C26.8061 20 28 18.8061 28 17.3333V2.66667C28 1.19391 26.8061 0 25.3333 0Z'
                    fill='#C70318'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 5.33333H28V14.6667H0V5.33333Z'
                    fill='#FFC500'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M12 8.296V11.656C12 12.5893 11.104 13.336 10 13.336H7.33333C6.232 13.3333 5.33333 12.5827 5.33333 11.6533V8.29333C5.33333 7.53066 5.93067 6.89333 6.752 6.68666C7 5.99333 7.76267 6.61466 8.66667 6.61466C9.576 6.61466 10.3333 5.99733 10.5813 6.688C11.4 6.9 12 7.53866 12 8.296Z'
                    fill='#D4AF2C'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M12 9.33333H13.3333V13.3333H12V9.33333ZM4 9.33333H5.33333V13.3333H4V9.33333Z'
                    fill='#CBCBCB'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M12 12H13.3333V13.3333H12V12ZM4 12H5.33333V13.3333H4V12Z'
                    fill='#1A47B8'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M12 8H13.3333V9.33333H12V8ZM4 8H5.33333V9.33333H4V8Z'
                    fill='#D4AF2C'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M6.66667 8H8V10H6.66667V8ZM9.33333 10.6667H10.6667V12.6667H9.33333V10.6667Z'
                    fill='#AF010D'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M6.66667 10.6667H8V12.6667H6.66667V10.6667Z'
                    fill='#FFC500'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M9.33333 8H10.6667V10H9.33333V8Z'
                    fill='#AE6A3E'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M8 8.00001L6.66667 6.66667H10.6667L9.33333 8.00001H8Z'
                    fill='#AF010D'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M8 5.33333H9.33333V6.66666H8V5.33333Z'
                    fill='#D4AF2C'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_297'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
